import { SlideOver } from 'ui/slideOver/SlideOver';
import { NBACampaignsSlideOverHeaderContent } from 'modules/ai/nba/components/campaigns/NBACampaignsSlideOverHeaderContent';
import { NBACampaignsSlideOverBodyContent } from './NBACampaignsSlideOverBodyContent';

type Props = {
  onClose: () => void;
  onClickOutside: () => void;
};

export const NBACampaignsSlideover = ({ onClose, onClickOutside }: Props) => {
  return (
    <SlideOver
      isOpen
      id={'nba-eligible-campaigns'}
      onClose={onClose}
      onClickOutside={onClickOutside}
      headerContent={<NBACampaignsSlideOverHeaderContent />}
      bodyContent={<NBACampaignsSlideOverBodyContent />}
    />
  );
};
